<div
  class="card-form-group-container"
  [formGroup]="form">
  <mat-form-field>
    <input
      matInput
      placeholder="Identificazione soggetto (SGTI)"
      formControlName="SGTI">
  </mat-form-field>
</div>
